import { cva } from 'class-variance-authority';

export const container = cva([
  'flex flex-col flex-1 items-center justify-center gap-4',
  'max-w-screen-2xl h-full',
  'overflow-y-auto',
]);

export const info = cva(['flex flex-col items-center justify-center gap-4']);

export const title = cva(['text-2xl font-bold text-center text-neutral-900']);

export const alerts = cva([
  'flex items-center justify-center gap-4',
  'max-w-screen-2xl w-full',
]);

export const alertDescription = cva([
  'flex flex-col items-start justify-center gap-2',
  'max-w-md',
]);

export const tableContainer = cva([
  'border rounded-lg',
  'divide-y divide-gray-200',
  'bg-white shadow',
  'flex flex-col w-full h-[calc(100vh-25rem)]',
]);

export const table = cva([
  'divide-y divide-gray-200',
  'flex flex-col flex-1 h-[calc(100%-6rem)] w-full',
]);

export const tableBody = cva([
  'bg-white rounded-b-lg h-full',
  'divide-y divide-gray-200',
  'flex-1 overflow-auto w-full',
]);

export const actions = cva([
  'flex flex-row-reverse flex-1 items-start justify-between gap-4',
  'w-full',
]);

export const form = cva(['flex flex-1 justify-center gap-2 ']);
